module.exports={Earlier:"較早",New:"新增",NoAnnouncements:"您沒有任何公告"};